import { Fragment, useCallback, useState } from 'react';
import Input from '../../../form/Input';
import { PRef } from '../ProductCreate';

/**
 * @author taulmax
 * @date 2024.10.11
 * @description 상품 등록 페이지 - 상품 간단 설명
 */
const PDescription = ({ pRef }: PRef<HTMLTextAreaElement>) => {
  const [pDescription, setPDescription] = useState<string>('');
  const onChangePDescription = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => setPDescription(e.target.value),
    []
  );

  return (
    <textarea
      ref={pRef}
      value={pDescription}
      onChange={onChangePDescription}
      placeholder="상품에 대한 간단한 설명을 입력하세요"
      className="!w-full !min-h-[80px] !px-3 !py-2.5 !border !border-gray-300 !rounded-lg !text-sm !resize-y !font-sans !transition-colors !duration-200 focus:!outline-none focus:!border-blue-400 placeholder:!text-gray-400"
    />
  );
};

export default PDescription;
